import { render, staticRenderFns } from "./InformacionSerieDocumental.vue?vue&type=template&id=1dd3a0a9"
import script from "./InformacionSerieDocumental.vue?vue&type=script&lang=js"
export * from "./InformacionSerieDocumental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dd3a0a9')) {
      api.createRecord('1dd3a0a9', component.options)
    } else {
      api.reload('1dd3a0a9', component.options)
    }
    module.hot.accept("./InformacionSerieDocumental.vue?vue&type=template&id=1dd3a0a9", function () {
      api.rerender('1dd3a0a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/unidad-compuesta/InformacionSerieDocumental.vue"
export default component.exports